import $http from "@/plugins/axios";

const RateService = {
    listRateAgentBySender(botCode, senderId) {
        return $http.get(`/live-support/rating-agent/by-sender/${botCode}/${senderId}`)
    },
    listRateAgentByTime(botCode, agentEmail, channel, fromDate, toDate) {
        return $http.get(`/live-support/rating-agent/group-by-time/${botCode}?agent_email=${agentEmail}&channel=${channel}&from=${fromDate}&to=${toDate}`)
    },
    listRateAgentOverall(botCode, agentEmail, channel, fromDate, toDate) {
        return $http.get(`/live-support/rating-agent/overall/${botCode}?agent_email=${agentEmail}&channel=${channel}&from=${fromDate}&to=${toDate}`)
    },
    listRateAgentDetails(botCode, agentEmail, channel, fromDate, toDate, page=null, page_size=null) {
        return $http.get(`/live-support/rating-agent/details/${botCode}?agent_email=${agentEmail}&channel=${channel}&from=${fromDate}&to=${toDate}&page=${page}&page_size=${page_size}`)
    },
    fetchRatingCfg(botCode) {
        return $http.get(`/live-support/rating-config/${botCode}`)
    },
    updateRatingCfg(botCode, data) {
        return $http.post(`/live-support/rating-config/${botCode}`, data)
    }
}
export default RateService